import SearchTags from './SearchTags';

export default SearchTags;
